export const colors = {
  black: '#272b2e',
  white: '#fff',
  grayscale: {
    600: '#99a3ab',
    400: '#d7dbdE',
    300: '#ebeff2',
    200: '#f6f8f9',
  },
  brand: {
    blue: '#265682',
    red: '#ff685d',
    primary: '#265682',
    secondary: '#ff685d',
  },
  gold: {
    900: '#c7a77b',
    800: '#d6bb96',
    600: '#ebe4da',
    400: '#fbf6f0',
  },
  success: '#1cbd9c',
  error: '#ff685d',
  warning: {
    dark: '#ab810a',
    light: '#feeeb6',
  },
  overlay: 'rgba(0, 0, 0, 0.5)',
  buttons: {
    cta: {
      hover: '#ff756b',
      active: '#f55a4e',
    },
    outline: {
      hover: '#ebeff2',
      active: '#f6f8f9',
    },
    normal: {
      hover: '#2c6599',
      active: '#224f78',
    },
    facebook: {
      hover: '#e5e5e5',
      active: '#eee',
    },
    google: {
      hover: '#e5e5e5',
      active: '#eee',
    },
    apple: {
      hover: '#e5e5e5',
      active: '#eee',
    },
  },
  inputBorder: '#e6e8e8',
  avatars: {
    orange: '#ffb45d',
    blue: '#5d9eff',
  },
  footer: {
    bg: '#234563',
    btn: 'rgba(255, 255, 255, 0.07)',
    btnHover: 'rgba(255, 255, 255, 0.11)',
    btnActive: 'rgba(255, 255, 255, 0.05)',
  },
  facebook: '#fff',
  google: '#fff',
  apple: '#fff',
};

export const discoverColors = {
  transparent: 'transparent',
  gray: {
    DEFAULT: colors.grayscale[600],
    950: colors.black,
    900: '#383838',
    600: '#5e6570',
    300: '#BDBDBD',
    200: colors.grayscale[400],
    100: colors.grayscale[300],
  },
  blue: {
    DEFAULT: colors.brand.blue,
    800: '#347198',
    600: '#6795B2',
    400: '#99B8CB',
    50: '#F2F6F9',
  },
  gold: {
    DEFAULT: colors.gold[900],
    700: '#744F20',
    500: '#D6BB96',
    400: '#EBE4DA',
    300: '#FBF6F0',
  },
  teal: {
    DEFAULT: '#5f9ea0',
  },
  coral: {
    DEFAULT: colors.brand.red,
    600: colors.buttons.cta.active,
    400: colors.buttons.cta.hover,
  },
};

export const designSystem = {
  'ds-black': '#000000',
  'ds-white': '#FFFFFF',
  'ds-transparent': 'transparent',

  'ds-alpha-black': {
    0: 'rgba(12, 17, 24, 0)',
    5: 'rgba(12, 17, 24, 0.05)',
    10: 'rgba(12, 17, 24, 0.1)',
    20: 'rgba(12, 17, 24, 0.2)',
    30: 'rgba(12, 17, 24, 0.3)',
    40: 'rgba(12, 17, 24, 0.4)',
    50: 'rgba(12, 17, 24, 0.5)',
    60: 'rgba(12, 17, 24, 0.6)',
    70: 'rgba(12, 17, 24, 0.7)',
    80: 'rgba(12, 17, 24, 0.8)',
    90: 'rgba(12, 17, 24, 0.9)',
  },
  'ds-alpha-brand': {
    0: 'rgba(208, 220, 240, 0)',
    5: 'rgba(208, 220, 240, 0.05)',
    10: 'rgba(208, 220, 240, 0.1)',
    20: 'rgba(208, 220, 240, 0.2)',
    30: 'rgba(208, 220, 240, 0.3)',
    40: 'rgba(208, 220, 240, 0.4)',
    50: 'rgba(208, 220, 240, 0.5)',
    60: 'rgba(208, 220, 240, 0.6)',
    70: 'rgba(208, 220, 240, 0.7)',
    80: 'rgba(208, 220, 240, 0.8)',
    90: 'rgba(208, 220, 240, 0.9)',
  },
  'ds-alpha-white': {
    0: 'rgba(255, 255, 255, 0)',
    5: 'rgba(255, 255, 255, 0.05)',
    10: 'rgba(255, 255, 255, 0.1)',
    20: 'rgba(255, 255, 255, 0.2)',
    30: 'rgba(255, 255, 255, 0.3)',
    40: 'rgba(255, 255, 255, 0.4)',
    50: 'rgba(255, 255, 255, 0.5)',
    60: 'rgba(255, 255, 255, 0.6)',
    70: 'rgba(255, 255, 255, 0.7)',
    80: 'rgba(255, 255, 255, 0.8)',
    90: 'rgba(255, 255, 255, 0.9)',
  },

  'ds-blue': {
    50: '#E3F7FC',
    100: '#D6EEF5',
    200: '#AEE4F5',
    300: '#77D1E7',
    400: '#46B2CC',
    500: '#1D98B6',
    600: '#177FA1',
    700: '#126881',
    800: '#094D62',
    900: '#003343',
    950: '#001A26',
  },
  'ds-brand': {
    25: '#FBFBFD',
    50: '#F0F3FB',
    100: '#E2E9F7',
    200: '#D0DCF0',
    300: '#B0C6E5',
    400: '#8CADD4',
    500: '#5B89B9',
    600: '#366B9B',
    700: '#225685',
    800: '#0E416B',
    900: '#022C4E',
    950: '#001C34',
  },
  'ds-error': {
    25: '#FFFAF9',
    50: '#FDEDED',
    100: '#FCE0E0',
    200: '#FCC8C4',
    300: '#FDA19B',
    400: '#FD665B',
    500: '#F74133',
    600: '#DE2823',
    700: '#B31B1A',
    800: '#8A000F',
    900: '#580808',
    950: '#360303',
  },
  'ds-gold': {
    25: '#FEFBF8',
    50: '#FAF2E6',
    100: '#F6E9D5',
    200: '#ECD8BB',
    300: '#D7BC97',
    400: '#C49D69',
    500: '#AB8343',
    600: '#926A31',
    700: '#744F20',
    800: '#5B3F1A',
    900: '#382509',
    950: '#1E1406',
  },
  'ds-gradient-blue': {
    0: 'rgba(41, 92, 163, 0)',
    100: 'rgba(41, 92, 163, 0.6)',
  },
  'ds-gray-light': {
    25: '#F7F7F8',
    50: '#EFF0F2',
    100: '#E6E8EB',
    200: '#D9DADE',
    300: '#BFC3C9',
    400: '#9DA3AC',
    500: '#7D848E',
    600: '#5E6570',
    700: '#48515D',
    800: '#2F3742',
    900: '#212831',
    950: '#0C1118',
  },
  'ds-gray-dark': {
    25: '#EFEFF1',
    50: '#E7E7EA',
    100: '#DADCE0',
    200: '#BCBFC5',
    300: '#9CA1A9',
    400: '#818691',
    500: '#646A74',
    600: '#4B505C',
    700: '#363B45',
    800: '#262A32',
    900: '#181B20',
    950: '#0D0F14',
  },
  'ds-pink': {
    50: '#FEEBF7',
    100: '#FDE1F3',
    200: '#F5CDE7',
    300: '#EAA9D5',
    400: '#D87EBC',
    500: '#CB5DA9',
    600: '#B44295',
    700: '#913175',
    800: '#6B2156',
    900: '#481039',
    950: '#310425',
  },
  'ds-purple': {
    50: '#F4EFFB',
    100: '#F0E6FB',
    200: '#E1D4F3',
    300: '#CAB6E2',
    400: '#B597D8',
    500: '#9B75C5',
    600: '#8759B5',
    700: '#71479B',
    800: '#522F74',
    900: '#3B1F55',
    950: '#210D32',
  },
  'ds-success': {
    25: '#F7FFF4',
    50: '#EBFBE7',
    100: '#D3F2CB',
    200: '#C1ECB5',
    300: '#84DB6A',
    400: '#62C542',
    500: '#47AC22',
    600: '#33910D',
    700: '#177620',
    800: '#165219',
    900: '#08330B',
    950: '#051B06',
  },
  'ds-teal': {
    50: '#E1F9F2',
    100: '#CAF4E8',
    200: '#A7EDDA',
    300: '#5DDBBF',
    400: '#19BDA0',
    500: '#24A58C',
    600: '#108772',
    700: '#126D61',
    800: '#0C5048',
    900: '#06312A',
    950: '#021D18',
  },
  'ds-warning': {
    25: '#FFFBF7',
    50: '#FFF2E5',
    100: '#FCE4CB',
    200: '#FED1A8',
    300: '#FBAE6E',
    400: '#FB8130',
    500: '#F2620B',
    600: '#E1480D',
    700: '#BB340C',
    800: '#8C1E01',
    900: '#591100',
    950: '#310702',
  },
  'ds-yellow': {
    50: '#FDF5D7',
    100: '#FCF1CA',
    200: '#F6DB80',
    300: '#F5C749',
    400: '#EEB01F',
    500: '#DA930C',
    600: '#BC741F',
    700: '#965319',
    800: '#743B13',
    900: '#4D2208',
    950: '#2C0D01',
  },
};
